export default {"src":"/_next/static/media/icon-engine-capacity.a20d6339.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};